import React from 'react';

import { DASHBOARD_URLS } from 'jsx/dashboard/urls';
import {
  InformationRequestType,
  INFORMATION_REQUEST,
} from 'jsx/informationRequest/constants';

import { ButtonContainer, Caption, MedicalRecordRequestLink } from './style';
import { Button, Heading } from '../style';

const InformationRequestStart = ({
  selectRequestType,
}: {
  selectRequestType: (type: InformationRequestType) => void;
}): JSX.Element => (
  <React.Fragment>
    <Heading>Want to access or delete your personal information?</Heading>
    <p>Just let us know how we can help.</p>
    <ButtonContainer>
      <Heading>Access your information</Heading>
      <Caption>
        We’ll create a PDF with the personal, non-medical information we’ve
        collected about you.
      </Caption>
      <Button
        buttonType="secondary"
        onClick={(): void => selectRequestType(INFORMATION_REQUEST.download)}
        data-test-id="download"
      >
        Start access request
      </Button>
    </ButtonContainer>
    <ButtonContainer>
      <Heading>Delete your information</Heading>
      <Caption>
        Request to delete the non-medical personal information in your profile.
      </Caption>
      <Button
        buttonType="secondary"
        onClick={(): void => selectRequestType(INFORMATION_REQUEST.delete)}
        data-test-id="delete"
      >
        Start deletion request
      </Button>
    </ButtonContainer>
    <MedicalRecordRequestLink href={DASHBOARD_URLS.requestMedicalRecord()}>
      Request your medical records
    </MedicalRecordRequestLink>
  </React.Fragment>
);

export default InformationRequestStart;
